export default __webpack_public_path__ + "static/media/banner_graphic.d54261b4.png";